import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { includes } from "lodash";
import { toPerformanceNumber } from "src/utils/performances";

const SmallStat = ({ date, stat }: { date: string; stat: string }) => {
  // A missing value (Private Equity returns an empty performances object)
  // used to coerce to NaN and render as "NaN" with a red down arrow.
  const value = toPerformanceNumber(stat);
  const isPositive = value !== null && value > 0;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span
        style={{
          color: "#475467",
          fontWeight: "700",
          fontSize: "16px",
          whiteSpace: "nowrap",
        }}
      >
        {date}
      </span>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: "16px",
          padding: "2px 10px 2px 8px",
          backgroundColor:
            value === null ? "#4754671A" : isPositive ? "#ECFDF3" : "#FEF3F2",
        }}
      >
        {value !== null &&
          (isPositive ? (
            <ArrowUpOutlined
              style={{
                color: "#12B76A",
                fontWeight: "700",
              }}
            />
          ) : (
            <ArrowDownOutlined
              style={{
                color: "#F04438",
                fontWeight: "700",
              }}
            />
          ))}
        <span
          style={{
            color: value === null ? "#475467" : isPositive ? "#027A48" : "#B42318",
            fontWeight: "500",
            whiteSpace: "nowrap",
          }}
        >
          {value === null ? "-" : (value * 100).toFixed(2)}
        </span>
      </div>
    </div>
  );
};
export { SmallStat as default };
export const MiniMetric = SmallStat;
